<template>
  <!-------------------------- Tablet Screens -------------------------->
  <!-- start -->
  <v-card
    v-if="$vuetify.breakpoint.width <= 980"
    elevation="0"
    class="px-5"
    :loading="loading"
    :class="loading ? '' : 'py-1'"
  >
    <!-- <div v-if="$vuetify.breakpoint.width <= 980"> -->
    <div class="d-flex mt-5">
      <v-text-field
        prepend-inner-icon="mdi-magnify"
        outlined
        :placeholder="$t('search')"
        dense
        v-model="search"
        @click:append="searchPack"
        @input="resetSearchOnEmpty"
        @keydown.enter="searchPack"
        class="shrink"
      ></v-text-field>
      <v-btn
        color="gray"
        height="40"
        width="40"
        max-width="40"
        outlined
        class="ml-8"
        @click="searchPack"
      >
        <v-icon>mdi-filter-outline</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <div class="py-1 title">{{ from }} - {{ to }} of {{ totalPacks }}</div>
      <v-btn
        class="mx-2"
        fab
        small
        outlined
        color="primary"
        :disabled="tabletTableOptions.page <= 1"
        @click="tabletPageChange(false)"
      >
        <v-icon dark> mdi-chevron-left </v-icon>
      </v-btn>
      <v-btn
        class="mx-2"
        fab
        small
        outlined
        color="primary"
        :disabled="tabletTableOptions.page >= totalPages"
        @click="tabletPageChange(true)"
      >
        <v-icon dark> mdi-chevron-right </v-icon>
      </v-btn>
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        left
        :min-width="417"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mx-2"
            fab
            small
            outlined
            color="primary"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon dark> mdi-cog-outline </v-icon>
          </v-btn>
        </template>

        <v-card width="417">
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ $t("customization") }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <div class="pl-3 pt-2 font-weight-normal">
              {{ $t("recordsPerPage") }}
            </div>
            <v-list-item>
              <v-list-item-content>
                <v-slider
                  v-model="itemsPerPageSlider"
                  :tick-labels="itemsPerPageOptions"
                  :max="3"
                  step="1"
                  ticks="always"
                  tick-size="4"
                ></v-slider>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-n3"></v-divider>
          </v-list>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col
                  class="mt-n9"
                  cols="6"
                  v-for="header in headers"
                  :key="header.value"
                >
                  <v-checkbox
                    v-model="selectedHeaders"
                    :label="header.text"
                    color="primary"
                    :value="header.text"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-layout justify-center>
            <v-card-actions class="mb-5">
              <v-spacer></v-spacer>

              <v-btn
                outlined
                color="primary"
                @click="resetDefaultSettings"
                width="190"
              >
                {{ $t("restoreDefault") }}
              </v-btn>
              <v-btn color="primary" width="190" @click="resetTableStructure">
                {{ $t("apply") }}
              </v-btn>
            </v-card-actions>
          </v-layout>
        </v-card>
      </v-menu>
    </div>
    <v-card
      v-for="(item, index) in items"
      :key="item.id"
      class="inner-card my-4 py-2 px-4"
      :elevation="0"
      :style="
        index % 2 !== 0 && {
          backgroundColor: 'rgba(243, 243, 243, 0.5)',
        }
      "
      @mouseover="selectItem(item)"
      @mouseleave="unSelectItem()"
    >
      <v-row no-gutters class="my-5">
        <v-col md="12">
          <v-card-text style="color: #00bd73" class="py-">Sire Id</v-card-text>
          <v-card-text class="py-1 headline font-weight-bold">{{
            `#${item.animalNumber}`
          }}</v-card-text>
        </v-col>
      </v-row>
      <v-row no-gutters class="my-5">
        <v-col md="4">
          <v-card-text style="color: #787878" class="py-1">Pack Id</v-card-text>
          <v-card-text class="py-1">{{ item.packId }}</v-card-text>
        </v-col>
        <v-col md="4">
          <v-card-text style="color: #787878" class="py-1"
            >Number Of Straws Ordered
          </v-card-text>
          <v-card-text class="py-1">{{ item.orderedStrawNum }}</v-card-text>
        </v-col>

        <v-col md="4">
          <v-card-text style="color: #787878" class="py-1"
            >Packing Technician</v-card-text
          >
          <v-card-text class="py-1">{{ item.packingTechnician }}</v-card-text>
        </v-col>
      </v-row>
      <v-btn
        x-small
        style="position: absolute; right: 10px; top: 15px"
        fab
        @click="
          $router.push({ name: 'EditPack', params: { id: item.SANumber } })
        "
      >
        <v-icon>mdi-pencil</v-icon></v-btn
      >
    </v-card>
    <!-- </div> -->
  </v-card>
  <!------------------------ End -------------------------->
  <div v-else class="mt-5">
    <div class="d-flex">
      <v-text-field
        prepend-inner-icon="mdi-magnify"
        outlined
        :placeholder="$t('search')"
        dense
        v-model="search"
        @click:append="searchPack"
        @input="resetSearchOnEmpty"
        @keydown.enter="searchPack"
        class="shrink"
      >
      </v-text-field>
      <v-tooltip top color="black" max-width="350">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on"> mdi-information-outline </v-icon>
        </template>
        <span
          >{{ $t('animal.searchByPackIdNumberOfStrawsOrderedPackingTechnicia') }}</span
        >
      </v-tooltip>
      <v-btn
        color="gray"
        height="40"
        width="40"
        max-width="40"
        outlined
        class="ml-8"
        @click="searchPack"
      >
        <v-icon>mdi-filter-outline</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <div class="py-1 title">{{ from }} - {{ to }} of {{ totalPacks }}</div>
      <v-btn
        class="mx-2"
        fab
        small
        outlined
        color="primary"
        :disabled="tableOptions.page <= 1"
        @click="pageChange(false)"
      >
        <v-icon dark> mdi-chevron-left </v-icon>
      </v-btn>
      <v-btn
        class="mx-2"
        fab
        small
        outlined
        color="primary"
        :disabled="tableOptions.page >= totalPages"
        @click="pageChange(true)"
      >
        <v-icon dark> mdi-chevron-right </v-icon>
      </v-btn>
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        left
        :min-width="417"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mx-2"
            fab
            small
            outlined
            color="primary"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon dark> mdi-cog-outline </v-icon>
          </v-btn>
        </template>

        <v-card width="417">
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ $t("customization") }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <div class="pl-3 pt-2 font-weight-normal">
              {{ $t("recordsPerPage") }}
            </div>
            <v-list-item>
              <v-list-item-content>
                <v-slider
                  v-model="itemsPerPageSlider"
                  :tick-labels="itemsPerPageOptions"
                  :max="3"
                  step="1"
                  ticks="always"
                  tick-size="4"
                ></v-slider>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-n3"></v-divider>
          </v-list>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col
                  class="mt-n9"
                  cols="6"
                  v-for="header in headers"
                  :key="header.value"
                >
                  <v-checkbox
                    v-model="selectedHeaders"
                    :label="header.text"
                    color="primary"
                    :value="header.text"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-layout justify-center>
            <v-card-actions class="mb-5">
              <v-spacer></v-spacer>

              <v-btn
                outlined
                color="primary"
                @click="resetDefaultSettings"
                width="190"
              >
                {{ $t("restoreDefault") }}
              </v-btn>
              <v-btn color="primary" width="190" @click="resetTableStructure">
                {{ $t("apply") }}
              </v-btn>
            </v-card-actions>
          </v-layout>
        </v-card>
      </v-menu>
    </div>
    <div class="table-section">
      <v-data-table
        :headers="tableHeaders"
        :items="items"
        :items-per-page="10"
        hide-default-footer
        item-key="id"
        v-model="selected"
        :loading="loading"
        :loading-text="$t('loadingData')"
        :options.sync="tableOptions"
        :server-items-length="totalPacks"
        :header-props="{
          'sort-icon': 'mdi-unfold-more-horizontal'
        }"
      >
        <template v-slot:progress>
          <v-progress-linear
            color="primary"
            :height="6"
            indeterminate
          ></v-progress-linear>
        </template>
        <template v-slot:no-data v-if="items.length < 1">
          NO Data AVAILABLE
        </template>
        <template v-if="items.length > 0" v-slot:body="{ items }">
          <tbody>
            <tr
              v-for="item in items"
              :key="item.id"
              style="position: relative; width: 0; height: 0"
              @mouseover="selectItem(item)"
              @mouseleave="unSelectItem()"
            >
              <!-- <td>
                <v-checkbox
                  multiple
                  v-model="selected"
                  :value="item"
                  hide-details
                  style="margin: 0px; padding: 0px"
                  v-on:click.stop=""
                />
              </td> -->
              <template>
                <td v-for="(h, index) in tableHeaders" :key="index">
                  <span class="text-center">
                    {{ item[h.value] }}
                  </span>
                </td>
              </template>
              <!-- <td>{{ item.animalNumber }}</td>
              <td>{{ item.packId }}</td>
              <td class="text-center">{{ item.orderedStrawNum }}</td>
              <td class="text-center">{{ item.packingTechnician }}</td> -->
              <div
                style="position: absolute; right: 10px; top: 4px"
                v-if="item === selectedItem"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      fab
                      v-bind="attrs"
                      v-on="on"
                      :to="{ name: 'EditPack', params: { id: item.SANumber } }"
                    >
                      <v-icon>mdi-pencil</v-icon></v-btn
                    >
                  </template>
                  <span>{{ $t('edit') }}</span>
                </v-tooltip>
              </div>
            </tr>
          </tbody>
        </template>
        <template v-slot:footer></template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import SemenService from "@/_services/SemenService";

export default {
  data() {
    return {
      from: 0,
      to: 0,
      totalPages: 1,
      totalPacks: 1,
      showingRows: 0,
      pageCount: 0,
      search: "",
      selected: [],
      menu: false,
      itemsPerPageSlider: 1,
      itemsPerPageOptions: [5, 10, 25, 50],
      selectedHeaders: [],
      tableHeaders: [],
      oldSelected: [],
      loading: true,
      selectedItem: false,
      tableOptions: {},
      tabletTableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
      allSelectedHeaders: [
        this.$t('sireID'),
        this.$t('animal.healthRecordInfo.packID'),
        this.$t('animal.numOfStrawsOrdered'),
        this.$t('packingTechnicia'),
      ],
      noRecordHeader: [
        this.$t('sireID'),
        this.$t('animal.healthRecordInfo.packID'),
        this.$t('animal.numOfStrawsOrdered'),
        this.$t('packingTechnicia'),
      ],
      headers: [
        {
          text: this.$t('sireID'),
          value: "animalNumber",
        },
        { text: this.$t('animal.healthRecordInfo.packID'), value: "packId" },
        {
          text: this.$t('animal.numOfStrawsOrdered'),
          align: "center",
          value: "orderedStrawNum",
        },
        {
          text: this.$t('packingTechnicia'),
          align: "center",
          value: "packingTechnician",
        },
      ],
      items: [],
    };
  },
  created() {
    if (this.checkBreakPoints) this.getTabletPack();
  },
  mounted() {
    this.tableHeaders = this.headers;
    this.selectedHeaders = this.allSelectedHeaders;
  },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  watch: {
    tableOptions: {
      handler() {
        this.getPackData();
      },
      deep: true,
    },
  },
  methods: {
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },
    resetDefaultSettings() {
      this.menu = false;
      this.tableHeaders = this.headers;
      this.selectedHeaders = this.allSelectedHeaders;
    },
    resetTableStructure() {
      this.tableHeaders = this.headers.filter((header) =>
        this.selectedHeaders.includes(header.text)
      );
      this.tableOptions.itemsPerPage =
        this.itemsPerPageOptions[this.itemsPerPageSlider];
      this.menu = false;
    },
    getPack() {
      SemenService.getPack(this.tableOptions, this.search)
        .then((res) => {
          this.items = res.data.sAutomationPack.rows;
          this.totalPacks = res.data.sAutomationPack.total_rows;
          // if (this.totalPacks < 1) {
          //   this.oldSelected = this.selectedHeaders;
          //   this.selectedHeaders = this.noRecordHeader;
          // } else {
          //   if (this.oldSelected.length > 1)
          //     this.selectedHeaders = this.oldSelected;
          //   else {
          //     this.selectedHeaders = this.allSelectedHeaders;
          //     this.oldSelected = [];
          //   }
          // }
          this.resetTableStructure();
          this.pageCount = Math.ceil(
            this.totalPacks / this.tableOptions.itemsPerPage
          );
          this.totalPages = Math.ceil(
            this.totalPacks / this.tableOptions.itemsPerPage
          );
          this.from =
            (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
          this.to =
            this.tableOptions.page * this.tableOptions.itemsPerPage -
            (this.tableOptions.itemsPerPage -
              res.data.sAutomationPack.num_rows);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTabletPack() {
      SemenService.getPack(this.tabletTableOptions, this.search)
        .then((res) => {
          console.log(res);
          this.items = res.data.sAutomationPack.rows;
          this.totalPacks = res.data.sAutomationPack.total_rows;
          this.pageCount = Math.ceil(
            this.totalPacks / this.tabletTableOptions.itemsPerPage
          );
          this.totalPages = Math.ceil(
            this.totalPacks / this.tabletTableOptions.itemsPerPage
          );
          this.from =
            (this.tabletTableOptions.page - 1) *
              this.tabletTableOptions.itemsPerPage +
            1;
          this.to =
            this.tabletTableOptions.page *
              this.tabletTableOptions.itemsPerPage -
            (this.tabletTableOptions.itemsPerPage -
              res.data.sAutomationPack.num_rows);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    searchPack() {
      if (this.search == "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.getTabletPack();
      } else {
        this.tableOptions.page = 1;
        this.getPack();
      }
    },

    resetSearchOnEmpty() {
      // if (this.search == "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.getTabletPack();
      } else {
        this.tableOptions.page = 1;
        this.getPack();
      }
    },

    getPackData() {
      this.getPack();
      // console.log(sortBy, sortDesc) // shortBy = email, sortDesc true/false
    },
    pageChange(t) {
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;

      this.getPackData();
    },
    tabletPageChange(t) {
      if (t) this.tabletTableOptions.page = this.tabletTableOptions.page + 1;
      else this.tabletTableOptions.page = this.tabletTableOptions.page - 1;
      this.getTabletPack();
    },
  },
};
</script>
<style lang="scss" scoped>
</style>